export default "__VITE_ASSET__7730237e__"